import { StatusChip, type ChipTone } from '@/components/common/StatusChip';
import type { QueueMessageStatus, QueuePriority, QueueBucketState } from '@/features/queue/types';

const status: Record<QueueMessageStatus, { tone: ChipTone; label: string }> = {
  delivering: { tone: 'info', label: 'Delivering' },
  deferred: { tone: 'warning', label: 'Deferred' },
  retrying: { tone: 'warning', label: 'Retrying' },
  held: { tone: 'neutral', label: 'Held' },
  failed: { tone: 'danger', label: 'Failed' },
  bounced: { tone: 'danger', label: 'Bounced' },
  queued: { tone: 'neutral', label: 'Queued' },
  delivered: { tone: 'success', label: 'Delivered' },
};

const priority: Record<QueuePriority, { tone: ChipTone; label: string }> = {
  high: { tone: 'danger', label: 'High' },
  normal: { tone: 'neutral', label: 'Normal' },
  low: { tone: 'info', label: 'Low' },
};

export function QueueStatusChip({ value }: { value: QueueMessageStatus }) {
  const v = status[value] ?? status.queued;
  return <StatusChip tone={v.tone}>{v.label}</StatusChip>;
}

export function QueuePriorityChip({ value }: { value: QueuePriority }) {
  const v = priority[value] ?? priority.normal;
  return <StatusChip tone={v.tone}>{v.label}</StatusChip>;
}

export function QueueStateChip({ value }: { value: QueueBucketState }) {
  return <StatusChip tone={value === 'paused' ? 'warning' : 'success'}>{value === 'paused' ? 'Paused' : 'Running'}</StatusChip>;
}
